import { gql } from 'apollo-boost';

export const SEND_MESSAGE_TO_SLACK = gql`
    mutation SendMessageToSlack($data: SendMessageToSlackInput!) {
        sendMessageToSlack(data: $data)
    }
`;
